import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class FurnitureandfittingService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/FurnitureAndFittings/';

  insert(data:any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'Insertfitting', data)
  }

  getfitting(id) {
    debugger
    return this.http.get(this.apiUrl + 'getfitting?id='+id)
  }

  getlastyearfitting(id) {
    debugger
    return this.http.get(this.apiUrl + 'getfittingLY?id=' + id)
  }
}
